import { OrderSummaryConfigType } from 'src/lib/types/customizeUI'
import Pill from '../skeletons/Pill'
import { Minus, Plus, Trash2 } from 'react-feather'

export interface ItemCardProps {
  orderSummaryConfig: OrderSummaryConfigType
  handleItemEdit?: (total: number) => void
  quantity?: number
  price?: number
  disabled?: boolean
}

export const ItemCard: React.FC<React.HTMLAttributes<HTMLDivElement> & ItemCardProps> = ({
  orderSummaryConfig,
  handleItemEdit,
  quantity,
  price,
  disabled,
  ...props
}) => {
  return (
    <div className='flex justify-between' {...props}>
      <div className='flex justify-start space-x-3'>
        <Pill height={4} width={4} />
        <div className='flex flex-col justify-between'>
          <Pill height={1} width={7.5} />
          {orderSummaryConfig?.isQuantityEditable && (
            <div className='flex h-6 w-[4.25rem] flex-row items-center rounded border border-gray-light'>
              <button
                className='flex h-full w-full grow basis-1/3 items-center justify-center cursor-pointer text-carbon-lighter rounded-l'
                disabled={disabled}
                onClick={() => handleItemEdit && handleItemEdit(-1)}
              >
                <Minus className='w-4 h-4' />
              </button>
              <p className='grow basis-1/3 text-center text-xs font-medium text-coal-dark'>{quantity ?? 1}</p>
              <button
                className='flex h-full w-full grow basis-1/3 items-center justify-center rounded-r cursor-pointer text-coal-light'
                disabled={disabled}
              >
                <Plus className='w-4 h-4' onClick={() => handleItemEdit && handleItemEdit(1)} />
              </button>
            </div>
          )}
        </div>
      </div>
      <div className='flex flex-col-reverse justify-between items-end'>
        <p className='pt-1 text-sm font-medium text-coal-dark'>
          <span className='flex flex-col space-y-1'>
            <span className='flex w-max min-w-fit max-w-max text-sm items-end flex-col'>
              {orderSummaryConfig?.isPriceStrikeThroughEnabled && (
                <span className='font-normal text-gray-dark line-through text-xs'>₹2000</span>
              )}
              <span>
                <span>₹{price ?? 700}</span>
              </span>
            </span>
          </span>
        </p>
        {orderSummaryConfig?.isQuantityEditable && (
          <button className='w-fit cursor-pointer rounded-lg border border-gray-light p-1'>
            <Trash2 className='w-4 h-4' />
          </button>
        )}
      </div>
    </div>
  )
}
